module.exports = __webpack_public_path__ + "media/images/bg/shapes/awards-a2fedfc801e5590fed5cd93b1d4e0a03.svg";